// @owners { team: patient-health }
// eslint-disable-next-line @alto/no-pocky-import
import { palette, spacing } from '@alto/pocky';
import React from 'react';
import styled from 'styled-components';
import {
  RENEWAL_STATE_NONE,
  type RenewalState,
} from '~shared/features/my-meds/selectors/getRenewalStateForPrescription';
import { isActiveRx } from '~shared/features/prescriptions/helper';
import { type Prescription } from '~shared/types/clients';
import { ADD_TO_CART_DISPLAY, type AddToCartDisplay } from './AddToCart';
import { AddToCart } from './AddToCart';
import NeedsInsurance from './NeedsInsuranceContainer';
import ProcessingInsurance from './ProcessingInsurance';
import { Renewal } from './Renewal';

type Props = {
  readonly prescription: Prescription;
  readonly renewalState: RenewalState;
  readonly hasUpcomingDeliveries?: boolean;
  readonly isNeedsInsurance: boolean;
  readonly isProcessingInsurance: boolean;
  readonly showAddToCartOnly?: AddToCartDisplay | null | undefined;
};
const PrescriptionActionContainer = styled.div`
  background-color: ${palette.altoColorsW};
  border: ${spacing.borderWidth} solid ${palette.grey2};
  padding: ${spacing.smSpacing};
  border-radius: ${spacing.borderRadius};
`;

const NoContainer = ({ children }: any) => <>{children}</>;

export default class PrescriptionAction extends React.PureComponent<Props> {
  renderContent() {
    const {
      hasUpcomingDeliveries,
      prescription,
      renewalState,
      isNeedsInsurance,
      isProcessingInsurance,
      showAddToCartOnly,
    } = this.props;
    const isActive = isActiveRx(prescription);
    const hasRenewalState = renewalState !== RENEWAL_STATE_NONE;

    if (showAddToCartOnly && showAddToCartOnly !== ADD_TO_CART_DISPLAY.NONE) {
      if (!isNeedsInsurance && !isProcessingInsurance && !hasUpcomingDeliveries && isActive) {
        return (
          <AddToCart
            prescription={prescription}
            showAddToCartOnly={showAddToCartOnly}
          />
        );
      }

      return null;
    }

    let content = null;

    if (isNeedsInsurance) {
      content = <NeedsInsurance />;
    } else if (isProcessingInsurance) {
      content = <ProcessingInsurance />;
    } else if (isActive) {
      if (showAddToCartOnly === ADD_TO_CART_DISPLAY.NONE) {
        return null;
      }

      content = <AddToCart prescription={prescription} />;
    } else if (hasRenewalState) {
      content = (
        <Renewal
          prescription={prescription}
          renewalState={renewalState}
        />
      );
    }

    const Container = isActive ? NoContainer : PrescriptionActionContainer;
    return <Container>{content}</Container>;
  }

  render() {
    const { prescription, renewalState, hasUpcomingDeliveries } = this.props;

    const isActive = isActiveRx(prescription);
    const hasRenewalState = renewalState !== RENEWAL_STATE_NONE;

    if (!hasUpcomingDeliveries && !isActive && !hasRenewalState) {
      return null;
    }

    return this.renderContent();
  }
}
